import { Component, Directive, ElementRef, Injector, ChangeDetectionStrategy } from "@angular/core";
import { UpgradeComponent } from "@angular/upgrade/static";

@Directive({
    selector: 'dashboard-directive',
    standalone: false,
})
export class DashboardDirective extends UpgradeComponent {
    constructor(elementRef: ElementRef, injector: Injector) {
        super('dashboard', elementRef, injector);
    }
}

@Component({
    selector: 'dashboard',
    template: '<dashboard-directive></dashboard-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DashboardComponent {

};

@Directive({
    selector: 'summary-directive',
    standalone: false,
})
export class SummaryDirective extends UpgradeComponent {
    constructor(elementRef: ElementRef, injector: Injector) {
        super('summary', elementRef, injector);
    }
}

@Component({
    selector: 'summary',
    template: '<summary-directive></summary-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SummaryComponent {

};


@Directive({
    selector: 'activity-directive',
    standalone: false,
})
export class ActivityDirective extends UpgradeComponent {
    constructor(elementRef: ElementRef, injector: Injector) {
        super('activity', elementRef, injector);
    }
}

@Component({
    selector: 'activity',
    template: '<activity-directive></activity-directive>',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ActivityComponent {

};